import { popover_position } from '../../util_components/popover_position';
import type { PopoverPos } from '../../util_components/popover_position';

// The Assign menu's fixed position, right-aligned to its trigger.
export const MENU_WIDTH = 300;
const MENU_HEIGHT = 300;

export type MenuPos = PopoverPos;

export const menu_position = (trigger: HTMLElement): MenuPos =>
  popover_position(trigger, { width: MENU_WIDTH, height: MENU_HEIGHT, align: 'right' });
